import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/shared/services/base.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class ReembolsoService extends BaseService{

  getRefundTypes() {
    let url = environment.portalApi + '/refund/ListTypes';
    return this.http.get(url, { headers: this.createHeader() });
  }

  getRefundStatus() {
      let url = environment.portalApi + '/refund/GetStatus';
      return this.http.get(url, { headers: this.createHeader() });
  }

  getRefundDocumentTypes() {
      let url = environment.portalApi + '/refund/ListDocumentTypes';
      return this.http.get(url, { headers: this.createHeader() });
  }

  saveRefund(model:any) {
      let url = environment.portalApi + '/refund/Save';
      return this.http.post(url, model, { headers: this.createHeader() });
  }

  getRefunds(filter: any) {
      let url = environment.portalApi + '/refund/ListRefunds?' + this.paramsToQueryString(filter);
      return this.http.get(url, { headers: this.createHeader() });
  }

  downloadRefundFile(param: any) {
      let url = environment.portalApi + '/refund/GetFile?' + this.paramsToQueryString(param);
      return this.http.get(url, { headers: this.createHeader(), responseType: 'blob' });
  }

  checkFileAlreadyUsed(param: any) {
      let url = environment.portalApi + '/refund/CheckFileAlreadyUsed?' + this.paramsToQueryString(param);
      return this.http.get(url, { headers: this.createHeader() });
  }

  getRefundableGuides(param: any) {
      let url = environment.portalApi + '/refund/RefundableGuides?' + this.paramsToQueryString(param);
      return this.http.get(url, { headers: this.createHeader() });
  }

  getParticipationDegree(param: any) {
      let url = environment.portalApi + '/refund/ParticipationDegree?' + this.paramsToQueryString(param);
      return this.http.get(url, { headers: this.createHeader() });
  }
  
  getOdontoProcedureInformation(param: any) {
      let url = environment.portalApi + '/refund/OdontoProcedure?' + this.paramsToQueryString(param);
      return this.http.get(url, { headers: this.createHeader() });
  }

}
